import React, { useState, useMemo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { 
  FolderGit2, 
  Search, 
  Calendar, 
  Building2, 
  Filter, 
  Globe, 
  Award, 
  ChevronRight,
  Sparkles
} from 'lucide-react';

// Single image import: update the path to your desired local asset
import GrantsHeroImg from '../../Media/1582313011457.jpg';

const projectsData = [
  {
    title: "Work Order for Engagement of IIT Delhi for Conducting a Study on Quality of Goods Procured, Transparency, Inclusiveness etc on GeM Portal",
    client: "Government e-Marketplace (GeM), Ministry of Commerce & Industry",
    year: "2025",
    category: "Government of India"
  },
  {
    title: "Endline Assessment of the Aarohan Project",
    client: "Committed Communities Development Trust, Mumbai, India",
    year: "2024",
    category: "Social Impact & Healthcare"
  },
  {
    title: "Situational Assessment and Documentation of Project Suraksha",
    client: "Committed Communities Development Trust, Mumbai, India",
    year: "2024",
    category: "Social Impact & Healthcare"
  },
  {
    title: "Detailed Feasibility Study on Setting up a 10 KLPD Bioethanol Plant Using Sawdust and Bamboo Dust in Tripura",
    client: "Tripura Renewable Energy Development Agency, India",
    year: "2024",
    category: "Sustainability & Industry"
  },
  {
    title: "Impact of Capacity Building through Digital Learning",
    client: "Institutional Capacity Initiative",
    year: "2024",
    category: "Innovation & EdTech"
  },
  {
    title: "Bridging the Urban-Rural Healthcare Gap through Telemedicine and Social Enterprises in India",
    client: "University of Queensland, Australia",
    year: "2024",
    category: "International Alliances"
  },
  {
    title: "Exploring the Dynamics of Urban Network Interactions for Enhanced Access to Social Entitlements",
    client: "Population Services International, India",
    year: "2024",
    category: "Social Impact & Healthcare"
  },
  {
    title: "Impact Assessment of the Interventions Aimed at Reducing Low Birth Weight in India",
    client: "William J Clinton Foundation, New Delhi, India",
    year: "2024",
    category: "Social Impact & Healthcare"
  },
  {
    title: "Advancing Public Health through Evidence and Engagement: A Comprehensive Advocacy Strategy",
    client: "Bio Usawa Inc, United States",
    year: "2024",
    category: "International Alliances"
  },
  {
    title: "Roundtable Consultation Workshop on Combatting AMR in India",
    client: "William J Clinton Foundation, New Delhi, India",
    year: "2023",
    category: "Social Impact & Healthcare"
  },
  {
    title: "Impact Assessment Study of Government E-Marketplace (GeM)",
    client: "Ministry of Commerce and Industry, New Delhi, India",
    year: "2023",
    category: "Government of India"
  },
  {
    title: "Examining the Impact of Global Tracker MINI on Reducing Vaccine Wastage",
    client: "B Medical Systems India Private Limited, Mumbai, India",
    year: "2023",
    category: "Sustainability & Industry"
  },
  {
    title: "Impact Assessment of Ministry of Education's Innovation Cell (MIC)",
    client: "All India Council For Technical Education (AICTE), New Delhi, India",
    year: "2023",
    category: "Government of India"
  },
  {
    title: "Reshaping Knowledge Sharing and Capacity Building through Digital Learning",
    client: "Empower School of Health Private Limited, Haryana, India",
    year: "2023",
    category: "Innovation & EdTech"
  },
  {
    title: "Role of Digital Interventions and Public Private Partnerships in Oxygen Management in India during COVID-19",
    client: "PATH, United States",
    year: "2023",
    category: "International Alliances"
  },
  {
    title: "Establishing the Need and Advantages of Partial Risk Guarantees (Sub Project under SAMRIDH Main Project RP04167)",
    client: "SAMRIDH Healthcare Blended Finance Facility",
    year: "2023",
    category: "Social Impact & Healthcare"
  },
  {
    title: "Development of a New Strategy and Re-Engineering of Business Processes for TADB",
    client: "NABARD Consultancy Services Private Limited (NABCONS), New Delhi, India",
    year: "2022",
    category: "Sustainability & Industry"
  },
  {
    title: "COVID-19 Associated Behavior to Build Sustainable Healthcare: Learnings from Indian and Australian Journey",
    client: "UQIDAR (University of Queensland – IIT Delhi Academy of Research)",
    year: "2022",
    category: "International Alliances"
  },
  {
    title: "Financial and Policy Modelling for Deep-Tech Startups in India",
    client: "School of Interdisciplinary Research (SiRe), IIT Delhi",
    year: "2022",
    category: "Innovation & EdTech"
  },
  {
    title: "COVID-19 Vaccine Roll Out: Institutional Management Partner",
    client: "Bill and Melinda Gates Foundation (BMGF)",
    year: "2021",
    category: "International Alliances"
  },
  {
    title: "Evaluation Partner for Awards for Excellence in District Skill Development Planning under SANKALP",
    client: "Ministry of Skill Development & Entrepreneurship",
    year: "2021",
    category: "Government of India"
  },
  {
    title: "Evaluation Study for the Scheme of Shahari Waqf Sampatti Vikas Yojana & Qaumi Waqf Board Taraqqiati Scheme",
    client: "Ministry of Minority Affairs",
    year: "2020",
    category: "Government of India"
  },
  {
    title: "Impact and Evaluation of Pre-Matric, Post-Matric & Merit-cum-Means Based Scholarship Schemes and Padho Pardesh",
    client: "Ministry of Minority Affairs",
    year: "2020",
    category: "Government of India"
  },
  {
    title: "Understanding the Antecedents of Innovation Implementation in Organizations",
    client: "CIMP, Patna",
    year: "2020",
    category: "Innovation & EdTech"
  },
  {
    title: "Impact of Artificial Intelligence on Productivity, Employability and Business Models in Healthcare (SPARC Project)",
    client: "Ministry of HRD (Ministry of Education), Government of India",
    year: "2019",
    category: "Government of India"
  },
  {
    title: "Berkeley-India IITD Innovation Platform",
    client: "Joint Initiative with UC Berkeley, USA",
    year: "2019",
    category: "International Alliances"
  },
  {
    title: "Understanding the National Innovation System and its Impact on Start-ups",
    client: "CIMP, Patna",
    year: "2019",
    category: "Innovation & EdTech"
  },
  {
    title: "Development of a Revenue/Business Model for Bioinformatics R&D in India Using Management Approach",
    client: "School of Interdisciplinary Research (SiRe), IIT Delhi",
    year: "2019",
    category: "Sustainability & Industry"
  },
  {
    title: "Evidence-Based Study for the Formulation of a Sustainable Policy for Haj Private Tour Operators for Next Five Years",
    client: "Ministry of Minority Affairs",
    year: "2018",
    category: "Government of India"
  },
  {
    title: "Comparative Study of the Role of Innovation Strategies in Different Institutional Contexts",
    client: "CIMP, Patna",
    year: "2018",
    category: "Innovation & EdTech"
  },
  {
    title: "Learning to Innovate: The Role of Exploration and Exploitation Strategies in Different Institutional Contexts",
    client: "ICSSR Indo-Swiss Joint Project (UNIL Switzerland)",
    year: "2017",
    category: "International Alliances"
  },
  {
    title: "Strategies in Volatile and Uncertain Environment for Emerging Markets",
    client: "NTPC Limited",
    year: "2017",
    category: "Sustainability & Industry"
  },
  {
    title: "Strategic Business Plan Development for Bamboo Industry in India (under BAANS Scheme)",
    client: "National Bamboo Mission / Government Initiative",
    year: "2016",
    category: "Sustainability & Industry"
  },
  {
    title: "Benchmarking of Performance of DGS&D Procurement Processes",
    client: "Directorate General of Supplies & Disposals (DGS&D), Ministry of Commerce and Industry",
    year: "2014",
    category: "Government of India"
  },
  {
    title: "Impact of Decentralization on DGS&D Procurement Process",
    client: "Directorate General of Supplies & Disposals (DGS&D), Ministry of Commerce and Industry",
    year: "2014",
    category: "Government of India"
  },
  {
    title: "Implementation and Application of Knowledge Transfer in MNCs: Indian-Western Context (New Faculty Grant)",
    client: "IRD, IIT Delhi",
    year: "2014",
    category: "Innovation & EdTech"
  },
  {
    title: "Evaluation of Skill Development of Group-D Employees in Bihar",
    client: "IL&FS / CIMP",
    year: "2013",
    category: "Social Impact & Healthcare"
  }
];

const categories = [
  "All", 
  "Government of India", 
  "International Alliances", 
  "Social Impact & Healthcare", 
  "Sustainability & Industry", 
  "Innovation & EdTech"
];

export default function GrantsResearchProjects() {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("All");

  const filteredProjects = useMemo(() => {
    return projectsData.filter((item) => {
      const matchesCategory = selectedCategory === "All" || item.category === selectedCategory;
      const matchesSearch = 
        item.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.client.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.year.includes(searchTerm);
      return matchesCategory && matchesSearch;
    });
  }, [searchTerm, selectedCategory]);

  return (
    <div className="container py-5 min-vh-100 position-relative text-light" style={{ zIndex: 1 }}>
      
      {/* 1. Header Banner */}
      <div className="row align-items-center g-5 mb-5">
        <div className="col-12 col-lg-7" data-aos="fade-right">
          <div className="d-inline-flex align-items-center gap-2 px-3 py-1 rounded-pill mb-3 sub-badge">
            <FolderGit2 size={16} className="text-cyan" />
            <span className="small text-light fw-medium">Sponsored Research & Policy Advisory</span>
          </div>

          <h1 className="display-5 fw-bold text-white mb-3">
            Grants, Research Projects & <span className="text-gradient">Consulting</span>
          </h1>

          <p className="lead text-secondary fs-6 mb-4 pe-lg-3">
            Over 35 high-impact sponsored initiatives funded by the Government of India, international 
            development consortiums, and premier multinational organizations.
          </p>

          {/* Quick Metrics */}
          <div className="d-flex flex-wrap gap-3">
            <div className="p-3 rounded-3 glass-card-sm text-center">
              <span className="fs-4 fw-bold text-cyan">35+</span>
              <span className="small text-secondary d-block" style={{ fontSize: '0.75rem' }}>Sponsored Grants</span>
            </div>
            <div className="p-3 rounded-3 glass-card-sm text-center">
              <span className="fs-4 fw-bold text-warning">10+</span>
              <span className="small text-secondary d-block" style={{ fontSize: '0.75rem' }}>Ministries & Foundations</span>
            </div>
            <div className="p-3 rounded-3 glass-card-sm text-center">
              <span className="fs-4 fw-bold text-info">2013 – 2025</span>
              <span className="small text-secondary d-block" style={{ fontSize: '0.75rem' }}>Active Tenures</span>
            </div>
          </div>
        </div>

        {/* Feature Image */}
        <div className="col-12 col-lg-5 text-center" data-aos="fade-left">
          <div className="position-relative p-2 rounded-4 glass-panel border-glow d-inline-block w-100">
            <img 
              src={GrantsHeroImg} 
              alt="Research and Consulting Engagements" 
              className="img-fluid rounded-4 shadow-lg w-100"
              style={{ maxHeight: '280px', objectFit: 'cover' }}
            />
          </div>
        </div>
      </div>

      {/* 2. Search & Category Filters */}
      <div className="p-4 rounded-4 glass-panel mb-5" data-aos="fade-up">
        <div className="row g-3 align-items-center justify-content-between">
          
          {/* Search Box */}
          <div className="col-12 col-md-5">
            <div className="position-relative">
              <Search size={18} className="text-secondary position-absolute top-50 start-0 translate-middle-y ms-3" />
              <input
                type="text"
                placeholder="Search projects by title, client, or year..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="form-control rounded-pill ps-5 bg-dark text-light border border-secondary border-opacity-50 py-2 small"
              />
            </div>
          </div>

          {/* Result Count */}
          <div className="col-12 col-md-auto text-md-end text-secondary small">
            Showing <strong className="text-white">{filteredProjects.length}</strong> of {projectsData.length} projects
          </div>
        </div>

        {/* Filter Badges with explicit highlight styling */}
        <div className="d-flex flex-wrap gap-2 mt-3 pt-3 border-top border-secondary border-opacity-25 align-items-center">
          <div className="d-flex align-items-center gap-1 text-secondary small me-2">
            <Filter size={14} /> Domain:
          </div>
          {categories.map((cat, idx) => {
            const isSelected = selectedCategory === cat;
            return (
              <button
                key={idx}
                type="button"
                onClick={() => setSelectedCategory(cat)}
                className="btn btn-sm rounded-pill px-3 py-1 transition-all"
                style={{
                  fontSize: '0.8rem',
                  fontWeight: isSelected ? '700' : '500',
                  color: isSelected ? '#0a0f1d' : '#94a3b8',
                  background: isSelected ? 'linear-gradient(135deg, #00f2fe, #4facfe)' : 'rgba(255, 255, 255, 0.05)',
                  border: isSelected ? '1px solid #00f2fe' : '1px solid rgba(255, 255, 255, 0.15)',
                  boxShadow: isSelected ? '0 0 14px rgba(0, 242, 254, 0.45)' : 'none'
                }}
              >
                {cat}
              </button>
            );
          })}
        </div>
      </div>

      {/* 3. Responsive Projects Stream */}
      <div className="row g-3">
        <AnimatePresence>
          {filteredProjects.map((item, index) => (
            <motion.div
              layout
              initial={{ opacity: 0, y: 15 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.95 }}
              transition={{ duration: 0.25 }}
              key={`${item.title}-${index}`}
              className="col-12 col-lg-6"
            >
              <div 
                className="p-4 rounded-4 glass-panel h-100 d-flex flex-column justify-content-between position-relative overflow-hidden"
                style={{
                  borderLeft: item.year === "2025" || item.year === "2024"
                    ? '4px solid #00f2fe'
                    : '4px solid rgba(255, 255, 255, 0.15)'
                }}
              >
                <div>
                  <div className="d-flex justify-content-between align-items-center gap-2 mb-2">
                    <span className="badge px-3 py-1 rounded-pill small bg-info bg-opacity-10 text-cyan border border-info border-opacity-25" style={{ fontSize: '0.72rem' }}>
                      {item.category}
                    </span>
                    <span className="small text-warning fw-semibold d-inline-flex align-items-center gap-1">
                      <Calendar size={13} /> {item.year}
                    </span>
                  </div>

                  <h5 className="text-white fw-bold fs-6 mb-2 lh-base">
                    {item.title}
                  </h5>
                </div>

                <div className="pt-3 mt-3 border-top border-secondary border-opacity-15 d-flex align-items-center gap-2 text-secondary small">
                  <Building2 size={15} className="text-cyan flex-shrink-0" />
                  <span className="text-truncate">{item.client}</span>
                </div>
              </div>
            </motion.div>
          ))}
        </AnimatePresence>

        {filteredProjects.length === 0 && (
          <div className="col-12 text-center py-5">
            <p className="text-secondary fs-5 mb-0">No research projects match your search query.</p>
          </div>
        )}
      </div>

    </div>
  );
}